import { Grid, TextField, FormHelperText } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStatisticsContext } from 'src/shared/contexts/statisticsContext';

export const StatisticsFilterDatePicker = () => {
  const { paymentDistStorageSearchFilter, setPaymentDistStorageSearchFilter } = useStatisticsContext();
  const { t } = useTranslation();
  const [toDateError, setToDateError] = useState('');

  const validateDates = (
    fromDate: string | number | Date | dayjs.Dayjs | null | undefined,
    toDate: string | number | Date | dayjs.Dayjs | null | undefined,
  ) => {
    if (toDate && fromDate) {
      const from = dayjs(fromDate);
      const to = dayjs(toDate);
      if (dayjs(to).isBefore(from)) {
        setToDateError(t('statistics:memberProgress.errors.toDateBeforeFromDate'));
        return false;
      }
      if (dayjs(to).isSame(from)) {
        setToDateError(t('statistics:memberProgress.errors.toDateEqualFromDate'));
        return false;
      }
    }
    setToDateError('');
    return true;
  };

  const handleFromDateChange = (newDate) => {
    setPaymentDistStorageSearchFilter((prev) => {
      const updatedFilter = { ...prev, start: newDate };
      validateDates(newDate, prev.end);
      return updatedFilter;
    });
  };

  const handleToDateChange = (newDate) => {
    setPaymentDistStorageSearchFilter((prev) => {
      const updatedFilter = { ...prev, end: newDate };
      if (validateDates(prev.start, newDate)) {
        return updatedFilter;
      }
      return prev;
    });
  };

  return (
    <>
      <Grid item xs={12} lg={3}>
        <DatePicker
          value={dayjs(paymentDistStorageSearchFilter.start)}
          format='YYYY-MM-DD'
          displayWeekNumber
          label={t('statistics:memberProgress.labels.timeFrom')}
          slotProps={{ textField: { size: 'small', fullWidth: true, InputLabelProps: { shrink: true } } }}
          onChange={handleFromDateChange}
          slots={{
            textField: TextField,
          }}
        />
      </Grid>

      <Grid item xs={12} lg={3}>
        <DatePicker
          value={dayjs(paymentDistStorageSearchFilter.end)}
          format='YYYY-MM-DD'
          displayWeekNumber
          label={t('statistics:memberProgress.labels.timeTo')}
          slotProps={{ textField: { size: 'small', fullWidth: true, InputLabelProps: { shrink: true }, error: Boolean(toDateError) } }}
          onChange={handleToDateChange}
          slots={{
            textField: TextField,
          }}
        />
        {toDateError && <FormHelperText error>{toDateError}</FormHelperText>}
      </Grid>
    </>
  );
};
